import { useEffect } from 'react';

export const useHiddenV1Container = () => {
  useEffect(() => {
    const v1Element = document.getElementById('v1-container');
    v1Element?.style.setProperty('display', 'none');
  }, []);
};
